import type {
  SharePointBrowseResponse,
  SharePointDocumentContent,
  SharePointDrive,
  SharePointFolderCountResponse,
  SharePointItem,
  SharePointSite,
} from "@/types";
import { api } from "../api";

export const sharepointService = {
  searchSites: (query?: string) => {
    const params = query ? `?q=${encodeURIComponent(query)}` : "";
    return api.get<SharePointSite[]>(`/sharepoint/sites${params}`);
  },

  listDrives: (siteId: string) => api.get<SharePointDrive[]>(`/sharepoint/sites/${siteId}/drives`),

  /** Get the current user's personal OneDrive as a drive (reuses drive/item browsing). */
  getMyOneDrive: () => api.get<SharePointDrive>("/sharepoint/onedrive/drive"),

  listItems: (driveId: string, params?: { folderId?: string; path?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.folderId) searchParams.set("folder_id", params.folderId);
    if (params?.path) searchParams.set("path", params.path);
    const qs = searchParams.toString();
    const path = `/sharepoint/drives/${driveId}/items${qs ? `?${qs}` : ""}`; // NOSONAR — template literal with conditional query string; ternary is the clearest expression
    return api.get<SharePointBrowseResponse>(path);
  },

  searchItems: (driveId: string, query: string) =>
    api.get<SharePointItem[]>(`/sharepoint/drives/${driveId}/search?q=${encodeURIComponent(query)}`),

  countFolderItems: (driveId: string, itemId: string, recursive: boolean = false) =>
    api.get<SharePointFolderCountResponse>(
      `/sharepoint/drives/${driveId}/items/${itemId}/count?recursive=${recursive}`,
    ),

  resolveUrl: (url: string) => api.get<SharePointItem>(`/sharepoint/resolve?url=${encodeURIComponent(url)}`),

  downloadDocument: (url: string) =>
    api.post<SharePointDocumentContent>(`/sharepoint/download?url=${encodeURIComponent(url)}`),
};
